import { SelectableModel } from "@pwc/common";

export class BaseModel extends SelectableModel {
  id: number;
  version?: number;
  flagValid?: boolean;
}
